import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootReducerType } from "@store/store";
import DashboardHeader from "@components/Header/DashboardHeader";
import ChatbotWidget from "@modules/chatbotwidget";

const PrivateRoute = () => {
  const { userLogginedIn } = useSelector((state: RootReducerType) => state.login);
  return userLogginedIn ? 
  <>
   <DashboardHeader />
    <Outlet /> 
    <ChatbotWidget />
  </>
  : <Navigate to="/" />;
};

export default PrivateRoute;
